import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { bindNavigate, applyActions } from './actions';

export default function VoiceLayer() {
  const navigate = useNavigate();

  useEffect(() => {
    bindNavigate(navigate);
  }, [navigate]);

  useEffect(() => {
    const onActions = (e) => applyActions(e.detail || [], { redFlag: false });
    window.addEventListener('vani:actions', onActions);
    return () => window.removeEventListener('vani:actions', onActions);
  }, []);

  return null;
}
